import React from 'react';
import { Checkbox, FormControlLabel, TextField } from '@mui/material';

import { InputFieldDef } from '../../../types/admin';

export const DefaultValueInput: React.FC<{
  field: InputFieldDef;
  error?: string;
  onChange: (value: unknown) => void;
}> = ({ field, error, onChange }) => {
  if (field.type === 'boolean') {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={field.default === true}
            onChange={(event) => onChange(event.target.checked)}
          />
        }
        label="Default"
      />
    );
  }

  return (
    <TextField
      label="Default"
      value={
        field.type === 'object' || field.type === 'object[]'
          ? typeof field.default === 'string'
            ? field.default
            : field.default === undefined
              ? ''
              : JSON.stringify(field.default, null, 2)
          : String(field.default ?? '')
      }
      onChange={(event) => onChange(event.target.value)}
      error={!!error}
      helperText={
        error || (field.type === 'object' || field.type === 'object[]' ? 'JSON value' : undefined)
      }
      multiline={field.type === 'object' || field.type === 'object[]'}
      rows={field.type === 'object' || field.type === 'object[]' ? 3 : 1}
    />
  );
};
